function normalizeHashPath(path: string): string {
  return String(path || '').startsWith('/') ? String(path || '') : `/${String(path || '')}`;
}

function toSearchParams(
  query?: URLSearchParams | Record<string, string | number | boolean | null | undefined>,
): URLSearchParams {
  if (!query) return new URLSearchParams();
  if (query instanceof URLSearchParams) return new URLSearchParams(query);

  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  return params;
}

export function buildHashRouteUrl(
  path: string,
  query?: URLSearchParams | Record<string, string | number | boolean | null | undefined>,
  origin = typeof window !== 'undefined' ? window.location.origin : '',
): string {
  const normalizedPath = normalizeHashPath(path);
  const params = toSearchParams(query);
  const search = params.toString();
  return `${origin}/#${normalizedPath}${search ? `?${search}` : ''}`;
}

export function isCurrentHashRoute(path: string): boolean {
  if (typeof window === 'undefined') return false;
  const normalizedPath = normalizeHashPath(path);
  const hash = String(window.location.hash || '');
  const hashPath = hash.startsWith('#/') ? hash.slice(1).split('?')[0] : '';
  return hashPath === normalizedPath || window.location.pathname === normalizedPath;
}

export function redirectToHashRoute(
  path: string,
  query?: URLSearchParams | Record<string, string | number | boolean | null | undefined>,
): void {
  if (typeof window === 'undefined') return;
  window.location.replace(buildHashRouteUrl(path, query));
}

export function buildNormalizedHashUrl(pathname: string, search = ''): string {
  const normalizedPath = normalizeHashPath(pathname || '/');
  const normalizedSearch = String(search || '').startsWith('?')
    ? String(search || '').slice(1)
    : String(search || '');
  return buildHashRouteUrl(normalizedPath, normalizedSearch ? new URLSearchParams(normalizedSearch) : undefined);
}
